import { render, staticRenderFns } from "./lunboXq.vue?vue&type=template&id=cdc53150&scoped=true&"
import script from "./lunboXq.vue?vue&type=script&lang=js&"
export * from "./lunboXq.vue?vue&type=script&lang=js&"
import style0 from "./lunboXq.vue?vue&type=style&index=0&id=cdc53150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc53150",
  null
  
)

export default component.exports